import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

import useEnterprise from 'components/Common/Enterprises/Hooks/useEnterprise';

import BlockPopup from './BlockPopup';
import UnlockPopup from './UnlockPopup';

export default function Popup({
  enterpriseId, userToken, onHide, onComplete,
}) {
  const enterprise = useEnterprise(enterpriseId);

  return (
    <Modal
      className="student inmodal auto without-overflow"
      show
      onHide={onHide}
    >
      {enterprise === null && <div className="text-center">Please, wait ...</div>}
      {enterprise && enterprise.attributes.is_lock && (
      <UnlockPopup
        enterprise={enterprise}
        onHide={onHide}
        onComplete={onComplete}
      />
      )}
      {enterprise && !enterprise.attributes.is_lock && (
      <BlockPopup
        enterpriseId={enterpriseId}
        userToken={userToken}
        onHide={onHide}
        onComplete={onComplete}
      />
      )}
    </Modal>
  );
}

Popup.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
  onHide: PropTypes.func.isRequired,
  userToken: PropTypes.string.isRequired,
  onComplete: PropTypes.func.isRequired,
};
